export interface MeetingCreateComparableFields {
  subject?: string;
  location?: string;
  scheduledStart?: Date | number | string;
  scheduledEnd?: Date | number | string;
}

export interface ShouldSkipPostCreateMeetingPatchOptions {
  isOffline: boolean;
  hasOfflineData: boolean;
  isAppointmentSecInfoConfigured: boolean;
  createFields: MeetingCreateComparableFields;
  finalFields: MeetingCreateComparableFields;
}

const normalizeText = (value?: string): string => (value || '').trim();

const normalizeTime = (value?: Date | number | string): number | null => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  if (value instanceof Date) {
    return value.getTime();
  }

  if (typeof value === 'number') {
    return value;
  }

  const numericValue = Number(value);
  if (!Number.isNaN(numericValue)) {
    return numericValue;
  }

  const parsedDate = new Date(value).getTime();
  return Number.isNaN(parsedDate) ? null : parsedDate;
};

export const areMeetingCreateFieldsEquivalent = (
  createFields: MeetingCreateComparableFields,
  finalFields: MeetingCreateComparableFields,
): boolean => (
  normalizeText(createFields.subject) === normalizeText(finalFields.subject)
  && normalizeText(createFields.location) === normalizeText(finalFields.location)
  && normalizeTime(createFields.scheduledStart) === normalizeTime(finalFields.scheduledStart)
  && normalizeTime(createFields.scheduledEnd) === normalizeTime(finalFields.scheduledEnd)
);

export const shouldSkipPostCreateMeetingPatch = ({
  isOffline,
  hasOfflineData,
  isAppointmentSecInfoConfigured,
  createFields,
  finalFields,
}: ShouldSkipPostCreateMeetingPatchOptions): boolean => (
  !isOffline
  && !hasOfflineData
  && isAppointmentSecInfoConfigured
  && areMeetingCreateFieldsEquivalent(createFields, finalFields)
);
